import React from 'react'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const DepreciationMethodDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList } = props

  return (
    <>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset Name'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.name}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset Start Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.Asset?.start_use_date)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Model No'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {listEl?.Asset?.model_no || 'N/A'}
        </div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'New Depreciation Method'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {listEl?.NewDepreciationMethod?.name}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {userList?.filter(user => user.ID == listEl?.submittedBy)[0]?.name ||
            'N/A'}
        </div>
      </div>

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]
                ?.name || 'N/A'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'REJECTED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.RejectionDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Remark'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
        </>
      )}

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Description'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.description || 'N/A'}</div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Reason'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason || 'N/A'}</div>
      </div>
    </>
  )
}
